export default __webpack_public_path__ + "static/media/32.df462ed1.png";